import React from 'react';

import { useSelector } from 'react-redux';

import { RootState } from '../../../redux';

import { useDispatch } from 'react-redux';

import { updateFormatOption } from '../../../redux/ChartPoperties/ChartControlsActions';

import PercentageCalculateButtons from './gaugeChartComponents/PercentageCalculateButtons';

import CurrencyInput from './gaugeChartComponents/CurrencyInput';

import RoundOffComponent from './gaugeChartComponents/RoundOffComponents';

/**

 * @returns Formatting UI for the AXIS LABEL in a Gauge chart

 */

const GaugeLabelFormat = ({
  iconColor,
  backgroundColor,
}: {
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const { gaugeChartFormats, propKey } = useSelector((state: RootState) => {
    const tabTileProps = state.tabTileProps;

    const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

    const gaugeChartFormats =
      state.chartControls.properties[propKey]?.formatOptions?.gaugeChartFormats;

    return { tabTileProps, gaugeChartFormats, propKey };
  });

  const dispatch = useDispatch();

  const handleLabelFormatUpdate = (option: string, value: any) => {
    const updatedValue = { ...gaugeChartFormats.labelFormat, [option]: value };

    dispatch(updateFormatOption(propKey, 'gaugeChartFormats', 'labelFormat', updatedValue));
  };

  const formatOptions: any[] = [
    { type: 'Number', value: 'Number' },

    { type: 'Currency', value: 'Currency' },

    { type: 'Percent', value: 'Percent' },
  ];

  const renderFormatOptions = () => {
    return formatOptions.map((item: any) => {
      const currentFormat = gaugeChartFormats?.labelFormat?.formatValue || 'Number';

      const isSelected = item.value === currentFormat;

      return (
        <div
          key={item.value}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',

            cursor: isSelected ? 'auto' : 'pointer',

            fontWeight: isSelected ? '600' : 'normal',
          }}
          onClick={() => {
            let updatedLabelFormat = {
              ...(gaugeChartFormats?.labelFormat || {}),

              formatValue: item.value,
            };

            if (item.value === 'Percent') {
              updatedLabelFormat.numberSeparator = 'None';
            }

            if (item.value === 'Currency') {
              if (!updatedLabelFormat.currencySymbol) {
                updatedLabelFormat.currencySymbol = '$';
              }
            }

            dispatch(
              updateFormatOption(propKey, 'gaugeChartFormats', 'labelFormat', updatedLabelFormat),
            );
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  const separatorOptions: any[] = [
    { type: 'None', value: 'None' },

    { type: 'Comma', value: 'Comma' },

    { type: 'Abbrev', value: 'Abbrev' },
  ];

  const renderSeparatorOptions = (searchIn: string) => {
    return separatorOptions.map((item: any) => {
      const isSelected = item.value === gaugeChartFormats?.[searchIn]?.numberSeparator;

      return (
        <div
          key={item.value}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',

            cursor: isSelected ? 'auto' : 'pointer',

            fontWeight: isSelected ? '600' : 'normal',
          }}
          className="radioButton"
          onClick={() => {
            if (gaugeChartFormats?.labelFormat?.formatValue === 'Percent') return;

            const updatedValue = {
              ...(gaugeChartFormats?.[searchIn] || {}),

              numberSeparator: item.value,
            };

            dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <div
        style={{
          borderTop: '1px solid rgb(211,211,211)',

          margin: '0.8rem 4% 0.8rem',
        }}
      ></div>
      <div
        className="optionDescription"
        style={{
          marginTop: '0',
          color: iconColor,
          marginBottom: '0px',
        }}
      >
        LABEL FORMAT
      </div>

      <div style={{ marginBottom: '10px' }}>
        <div className="optionDescription" style={{ marginTop: '0px', color: iconColor }}>
          Format Value
        </div>

        <div className="radioButtons" style={{ padding: '0' }}>
          {renderFormatOptions()}
        </div>
      </div>

      <React.Fragment>
        {gaugeChartFormats?.labelFormat?.formatValue === 'Percent' ? (
          <>
            <PercentageCalculateButtons
              searchIn="labelFormat"
              propKey={propKey}
              iconColor={iconColor}
            />
          </>
        ) : (
          <></>
        )}

        {gaugeChartFormats?.labelFormat?.formatValue === 'Currency' ? (
          <>
            <CurrencyInput searchIn="labelFormat" propKey={propKey} iconColor={iconColor} />
          </>
        ) : null}

        {gaugeChartFormats?.labelFormat?.formatValue !== 'Percent' && (
          <>
            <div className="optionDescription" style={{ marginTop: '0.1rem', color: iconColor }}>
              Separator
            </div>

            <div className="radioButtons" style={{ paddingLeft: '0.1rem', margin: 'auto' }}>
              {renderSeparatorOptions('labelFormat')}
            </div>
          </>
        )}

        <RoundOffComponent
          searchIn="labelFormat"
          propKey={propKey}
          iconColor={iconColor}
          backgroundColor={backgroundColor}
        />
      </React.Fragment>
    </React.Fragment>
  );
};

export default GaugeLabelFormat;
